import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { SymbolSyntheticAction } from '../symbolSynthetic.action';

export const startSymbolSyntheticProcessingEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    SymbolSyntheticAction.create.started,
    SymbolSyntheticAction.update.started,
    SymbolSyntheticAction.remove.started,
  ),
  mergeMap(() => {
    return [
      SymbolSyntheticAction.processing.started(),
    ];
  }),
);
